import { useMemo } from "react"
import { useAppSelector } from "state/hooks"
import { selectCurrentUser } from "./reducer"

export const useUser = () => {
    const user = useAppSelector(selectCurrentUser)
    return useMemo(() => ({ user }), [user])
  }